export default __webpack_public_path__ + "ddcd9e5c1cc81524153e733592e323f7.svg";